import { mapState } from 'vuex'
import { IDR } from '@/libs/currency'
import ModalConfirm from '@/views/components/modal/ModalConfirm.vue'

export default {
  name: 'SettingEkspedisiKomship',
  components: { ModalConfirm },
  data() {
    return {
      loading: true,
      expedition: [],
      address: [],
      ninja: null,
      ninjaIndex: null,
      IDR,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  created() {
    this.checkAddress()
    this.getExpedition()
  },
  methods: {
    async getExpedition() {
      const setDescription = (name, cashbackTo, isFlat, flatFee, jaboFee) => {
        const cashbacksReg = cashbackTo.find(item => item.service_alias === 'Reguler')?.cashback_to
        const cashbacksCargo = cashbackTo.find(item => item.service_alias === 'Cargo')?.cashback_to
        const cashbacksHalu = cashbackTo.find(item => item.service_alias === 'HALU')?.cashback_to
        const cashbacksLite = cashbackTo.find(item => item.service_alias?.toLowerCase().includes('lite'))?.cashback_to

        const discount = []
        const crossborder = []
        const flat = []
        let learnMore = ''
        let recomend = ''

        if (name === 'SPX') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b> 🔥`)
          discount.push('<b>SPX Express</b> memberikan gratis biaya ongkir berangkat dan ongkir retur saat tingkat retur kirimanmu kurang dari 20% di bulan sebelumnya.')
          learnMore = 'https://bantuan.komerce.id/id/article/program-gratis-ongkir-bolak-balik-spx-di-komship-erdcme/?bust=1758189095543'
          recomend = '<b>SPX Express</b> mempunyai  jangkauan pengiriman yang cukup luas di seluruh Indonesia dan menerapkan prosedur pengiriman yang tinggi, termasuk kebersihan dan keamanan paket.'
        } else if (name === 'IDEXPRESS') {
          if (cashbacksReg) discount.push(`Berat di atas 500 gram (STD), diskon <b>${cashbacksReg}%</b>`)
          if (cashbacksLite) discount.push(`Berat di bawah 500 gram (IDLite), <b>kurang lebih bayar 1/2-nya</b> ditambah diskon ${cashbacksLite}%`)
          if (cashbacksCargo) discount.push(`<b>Cargo (ID Truck)</b> Diskon ongkir ${cashbacksCargo}%, untuk orderan yang beratnya lebih dari 5 kg`)
          learnMore = 'https://bantuan.komerce.id/id/article/komship-flat-4qjp82/?bust=1765870044557'
          recomend = 'Diskon mantap paket ringan <b><1/2 kg</b> dan <b>antar kota besar retur rendah</b>'

          if (isFlat) {
            flat.push(`<span class="text-black">Kirim dari Jawa ke Jawa dan Jawa ke Sumatera mulai dari <b>${IDR(flatFee)}/kg</b> saja</span>`)
            flat.push('<span class="text-black">Flat akan aktif di area tersebut</span>')
            flat.push('<span class="text-black">Kamu tetap dapat menggunakan layanan Lite di selain area Jawa dan Sumatera</span>')
          }
        } else if (name === 'JNE') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b>`)
          discount.push('Belum tersedia layanan OKE dan YES di Komship')
          if (cashbacksCargo) discount.push(`<b>Cargo (JNE Trucking)</b> Diskon ongkir ${cashbacksCargo}%, untuk orderan yang beratnya lebih dari 5 kg`)
          recomend = 'Cabang sangat banyak, retur lebih rendah kirim paket ke <b>daerah terpencil</b>'

          if (isFlat) {
            if (jaboFee !== 0) flat.push(`<span class="text-black">Kirim dari dan ke JABODETABEK dengan jangkauan 100% cuma <b>${IDR(jaboFee)}/kg</b></span>`)
            flat.push(`<span class="text-black">Kirim dari dan ke Jawa dengan jangkauan 100% cuma <b>${IDR(flatFee)}/kg</b></span>`)
            flat.push('<span class="text-black">Untuk dari dan tujuan ke luar jawa maka kamu masih bisa menikmati segala fasilitas Non-FLAT ini</span>')
            flat.push(`<span class="text-[#D19D04]">${name}FLAT otomatis Aktif. Jika kirim dari dan ke Jawa</span>`)
          }
        } else if (name === 'SICEPAT') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b>`)
          if (cashbacksHalu) discount.push(`Halu <b>${cashbacksHalu}%</b>`)
          if (cashbacksCargo) discount.push(`Cargo (GOKIL) minimal 10kg, <b>mulai dari</b> Rp. 2.500,- / kg ditambah diskon ${cashbacksCargo}%`)
          recomend = '<b>Harga mulai 5 ribu</b> pengiriman ke seluruh Indonesia. <br>Diskon mantap paket reguler >1kg  dan <b>antar kota besar</b> retur rendah'
        } else if (name === 'SAP') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b>`)
          if (cashbacksCargo) discount.push(`<strong>Cargo (SAP Trucking)</strong> Diskon ongkir ${cashbacksCargo}%, untuk orderan yang beratnya lebih dari 5 kg`)
          recomend = 'Ekspedisi Pelopor COD, Kirim COD <strong>luar jawa</strong> bisa diandalkan, dan CS Supportif'
        } else if (name === 'J&T') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b>`)
          discount.push('Belum tersedia layanan <strong>J&T Super (Same Day & Next Day)</strong> di Komship.')
          recomend = 'Memiliki coverage area terbesar dan dapat menjangkau pengiriman Se-Indonesia tanpa pihak ke-3. Operational dan layanan Customer Service 24/7.'
        } else if (name === 'NINJA') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b> 🔥`)
          discount.push('Belum tersedia layanan <strong>Ninja Sameday</strong> dan <strong> Cargo </strong> di Komship.')
          crossborder.push('Kami bantu bisnis Anda go-international! Pengiriman cepat dan aman ke <b>Malaysia</b> dan <b>Singapura</b> dengan tarif yang terjangkau.')
          recomend = `Diskon mantap ${cashbacksReg}% dan pengiriman dilakukan setiap hari (Senin-Minggu). <br> <span class="text-danger">*Tidak termasuk libur nasional</span>`
        } else if (name === 'LION') {
          if (cashbacksReg) discount.push(`Reguler <b>${cashbacksReg}%</b> 🔥`)
          discount.push('Lion Parcel cocok untuk pengiriman paket ringan hingga menengah dengan jangkauan luas ke luar Pulau Jawa')
          learnMore = 'https://bantuan.komerce.id/id/article/lion-parcel-komship-1k1369t/?bust=1768466062797'
          recomend = 'Jangkauan luas ke berbagai wilayah Indonesia, didukung jaringan Lion Group. Tersedia layanan <strong>REGPACK</strong> dan <strong>BIGPACK</strong> mulai 10 kg dengan solusi pengiriman yang kompetitif untuk antar pulau.'
        }

        return {
          discount, crossborder, recomend, flat, learnMore,
        }
      }

      await this.$http_komship.get('/v2/partner/shipment/not-active')
        .then(response => {
          const { data } = response.data
          this.expedition = data.list_shipments.map(item => ({
            id: item.id,
            shipping_name: item.shipping_name,
            image_path: item.image_path,
            is_active: item.is_active === 1,
            desc: setDescription(item.shipping_name, item.cashbacks, item.flat_service !== null, item.flat_service?.flat_fee || 0, item.flat_service?.jabo_fee || 0),
            is_flat: !!item.flat_service,
            flat_fee: item.flat_service?.flat_fee || 0,
            jabo_fee: item.flat_service?.jabo_fee || 0,
            is_crossborder: item.shipping_name === 'NINJA',
          }))
          this.loading = false
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal update ekspedisi, silahkan coba lagi' })
          this.loading = false
        })
    },
    collapseExpedition(id) {
      this.$root.$emit('bv::toggle::collapse', id)
    },
    validateExpeditions(value) {
      if (value.shipping_name === 'NINJA' && this.profile.partner_is_crossborder && !value.is_active) {
        this.ninja = value
        this.ninjaIndex = this.expedition.findIndex(items => items.id === value.id)
        if (this.profile.role_id === 4) {
          this.$bvModal.show('modal-validation-ninja')
        } else {
          this.$bvModal.show('modal-validation-ninja-account-access')
        }
      } else {
        this.setExpedition(value)
      }
    },
    closeModalNinja() {
      this.$set(this.expedition[this.ninjaIndex], 'is_active', true)
      this.$bvModal.hide('modal-validation-ninja')
    },
    closeModalNinjaAccountAccess() {
      this.$set(this.expedition[this.ninjaIndex], 'is_active', true)
      this.$bvModal.hide('modal-validation-ninja-account-access')
    },
    async setExpedition(expedition) {
      if (this.address.length > 0) {
        await this.$http_komship.put(`/v1/partner/shipment/update/${expedition.id}`, {
          shipping_name: expedition.shipping_name,
          is_active: expedition.is_active ? 1 : 0,
          partner_id: this.profile.partner_id,
          is_komship: 1,
        })
          .then(() => {
            if (expedition.shipping_name === 'NINJA') this.$bvModal.hide('modal-validation-ninja')
            this.$toast_success({ message: `${expedition.is_active ? 'Berhasil mengaktifkan ekspedisi' : 'Berhasil menonaktifkan ekspedisi'}` })
            this.$store.dispatch('dashboard/getProfile')
            this.$forceUpdate()
          })
          .catch(() => {
            this.$toast_error({ message: 'Gagal update setting ekspedisi, silahkan coba lagi' })
          })
      } else {
        this.$swal({
          title: '<span class="text-[18px]">Untuk dapat mengaktifkan ekspedisi ini, Kamu harus melengkapi bagian Kelurahan/Kecamatan pada Alamat Pickup</span>',
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
          confirmButtonText: 'Lengkapi Alamat Pickup',
          confirmButtonClass: 'btn btn-primary rounded-lg',
          allowOutsideClick: false,
        }).then(res => {
          if (res.isConfirmed) {
            this.$router.push('/gudangku')
          }
        })
      }
    },
    async checkAddress() {
      await this.$http_komship.get('/v3/address')
        .then(response => {
          const { data } = response.data
          this.address = data
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data, silahkan coba lagi' })
        })
    },
  },
}
